import { Button, Form, Icon, Input, Title } from '@fnacdarty/back-office-ui';
import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
	StyledContainer,
	StyledTitleContainer,
	StyledError,
	StyledBlock,
	StyledSuccess,
} from './index.styled';
import { resetPassword } from '../../utils/auth';
import { useForm } from '../../../../hooks';
import { BrandHeadBar } from '../../../../layouts';
import * as errors from '../../../../utils/errors';

const ResetPassword = () => {
	const theme = useTheme();

	const [showPassword, isPasswordShow] = useState(false);
	const [showNewPassword, isNewPasswordShow] = useState(false);
	const [showConfirmNewPassword, isConfirmNewPasswordShow] = useState(false);
	const [isPasswordChanged, setIsPasswordChanged] = useState(false);
	const [userMail, setUserMail] = useState('none');
	const [token, setToken] = useState('none');

	const togglePassword = () => {
		isPasswordShow(!showPassword);
	};

	const toggleNewPassword = () => {
		isNewPasswordShow(!showNewPassword);
	};

	const toggleConfirmNewPassword = () => {
		isConfirmNewPasswordShow(!showConfirmNewPassword);
	};

	const [status, setStatus] = useState({
		loading: false,
		error: '',
		message: '',
	});
	const { formData, handleOnChange } = useForm({
		userMail: '',
		newPassword: '',
		confirmNewPassword: '',
	});

	const navigate = useNavigate();
	const handleHomeRedirect = () => {
		navigate('/');
	};

	const handleFormSubmit = async (event) => {
		event.preventDefault();

		setStatus({ ...status, loading: true });

		const payload = {
			mailAddress: formData.userMail,
			newPassword: formData.newPassword,
			confirmNewPassword: formData.confirmNewPassword,
		};

		if (formData.confirmNewPassword !== formData.newPassword) {
			const message = [
				{
					message: 'Les mots de passe ne correspondent pas !',
				},
			];
			return setStatus({
				...status,
				error: message,
				loading: false,
			});
		}
		const res = await resetPassword(payload, token);
		if (res.success) {
			setIsPasswordChanged(true);
			setUserMail(res.data.userMail);
		}
		const messagesErrors = [];

		if (res.message) {
			if (Array.isArray(res.message)) {
				res.message.forEach((item) => {
					if (errors.BIND_API_USER_PASSWORD_ERRORS[item.message]) {
						messagesErrors.push({
							message:
								errors.BIND_API_USER_PASSWORD_ERRORS[
									item.message
								],
						});
					} else {
						messagesErrors.push({
							message: item.message,
						});
					}
				});
			} else if (errors.BIND_API_USER_PASSWORD_ERRORS[res.message]) {
				messagesErrors.push({
					message: errors.BIND_API_USER_PASSWORD_ERRORS[res.message],
				});
			} else {
				messagesErrors.push({
					message: res.message,
				});
			}
		}

		return setStatus({
			...status,
			error: messagesErrors,
			loading: false,
		});
	};

	useEffect(() => {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const urltoken = urlParams.get('token');
		setToken(urltoken);
	}, []);

	return (
		<>
			<BrandHeadBar />
			<StyledContainer>
				<StyledTitleContainer>
					<Title level={2}>Nouveau mot de passe</Title>
				</StyledTitleContainer>
				{!isPasswordChanged ? (
					<>
						<Form onSubmit={handleFormSubmit}>
							<StyledBlock>
								<Input
									name="newPassword"
									type={showNewPassword ? 'text' : 'password'}
									placeholder="Nouveau mot de passe"
									required
									label="Nouveau mot de passe"
									value={formData.newPassword}
									onChange={handleOnChange}
								/>
								<span
									style={{
										position: 'absolute',
										right: '28px',
										top: '14px',
									}}
								>
									<Icon
										name="eye"
										width={20}
										style={{
											position: 'absolute',
											float: 'right',
										}}
										onClick={toggleNewPassword}
										color={
											showNewPassword
												? theme.colors.primary
												: theme.colors.muted
										}
									/>
								</span>
							</StyledBlock>
							<StyledBlock>
								<Input
									name="confirmNewPassword"
									type={
										showConfirmNewPassword
											? 'text'
											: 'password'
									}
									placeholder="Confirmer mot de passe"
									required
									label="Confirmer nouveau mot de passe"
									value={formData.confirmNewPassword}
									onChange={handleOnChange}
								/>
								<span
									style={{
										position: 'absolute',
										right: '28px',
										top: '14px',
									}}
								>
									<Icon
										name="eye"
										width={20}
										style={{
											position: 'absolute',
											float: 'right',
										}}
										onClick={toggleConfirmNewPassword}
										color={
											showConfirmNewPassword
												? theme.colors.primary
												: theme.colors.muted
										}
									/>
								</span>
							</StyledBlock>
							<br></br>
							<Button
								type="submit"
								style={{
									backgroundColor: theme.colors.portail,
								}}
							>
								{status.loading ? 'Chargement...' : 'Valider'}
							</Button>
						</Form>
						<Button
							style={{
								backgroundColor: theme.colors.primaryLight,
								marginTop: '6px',
							}}
							onClick={handleHomeRedirect}
						>
							Annuler
						</Button>
						<div>
							Le mot de passe doit être composé au minimum de 8
							caractères,
						</div>
						<div>
							comporter au moins 1 lettre majuscule, 1 lettre
							minuscule, 1 chiffre
						</div>
						<div>et 1 caractère spécial</div>
					</>
				) : (
					<>
						<StyledSuccess className="succes">
							Votre demande a bien été prise en compte.
						</StyledSuccess>
						<StyledSuccess className="succes">
							Un e-mail vous a été envoyé.
						</StyledSuccess>
						<Button
							style={{ backgroundColor: theme.colors.primary }}
							onClick={handleHomeRedirect}
						>
							Fermer
						</Button>
					</>
				)}
				{status.error
					? status.error.map((item, index) => (
							<StyledError key={index} className="error">
								{item.message}
							</StyledError>
					  ))
					: null}
			</StyledContainer>
		</>
	);
};

export default ResetPassword;
